<template>
    <div>
        <nav-bar-main></nav-bar-main>

        <b-alert v-if="plantDetails != null && plantDetails.plant_type == 'basic'" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro/>
        </b-alert>

        <b-alert v-if="plantDetails != null && $store.getters.isProExpired" show variant="warning" style="display:inline-block;width:100%">
            <banner-pro-expired/>
        </b-alert>

        <div v-if="error != null" class="alert alert-danger" role="alert">
            {{$t(error)}}
        </div>

        <Loader />
        <div v-if="plantDetails != null && monitoringZonesDetails !=null" class="animated fadeIn container-fluid">

            <!-- Cards  -->
            <div style="margin-top:10px">

                <b-row class="mt-2 justify-content-center">
                    <b-col v-for="item in lampsTableEnergy" v-bind:key="item.zoneId"  xl="4" lg="4" md="6" class="mt-4">
                        <b-card class="radius-card">

                            <div slot="header">
                                <b-row>
                                    <!--  -->
                                    <b-col cols="8" class="ml-2">
                                        <b-row>
                                            <div style="color:#009DE0">
                                                <h5>{{$t("monitoring_zone.zone")}} {{ item.zoneNumber }}</h5>
                                            </div>
                                        </b-row>
                                        <b-row>
                                            <!-- monitoring zone with editing mode -->
                                            <span>
                                                <span v-if="!editingZone || item != currentZone"  class="typo-label"><strong>{{ item.zoneName }}</strong></span>
                                                <span v-if="!editingZone"><b-button style="background-color:transparent;" class="ml-2" @click="editZoneName(item)"><i class="fa fa-edit"></i></b-button></span>
                                                <span v-if="editingZone && item == currentZone">
                                                    <div role="group">
                                                        <b-form-input type="text" v-model="nameZone" :maxlength="maxchar"></b-form-input>
                                                        <b-form-text v-html="zoneNameInfo"></b-form-text>
                                                    </div>
                                                </span>
                                                <span v-if="editingZone && item == currentZone">
                                                    <b-button style="background-color:transparent;" class="ml-2" v-if="!updatingName" @click="saveZoneName"><i
                                                            class="fa fa-check"></i></b-button>
                                                    <b-button style="background-color:transparent;" class="ml-2" v-if="!updatingName" @click="abortZoneName"><i
                                                            class="fa fa-close"></i></b-button>
                                                    <span v-if="updatingName"><i class="fa fa-spinner fa-spin"></i></span>
                                                </span>
                                            </span>
                                        </b-row>
                                    </b-col>

                                    <b-col cols="3" class="d-flex justify-content-end">
                                    <!-- delete zone button -->
                                        <b-row class="align-items-center">
                                            <b-col cols="6">
                                                <div v-if="item.energy_lamps!=null && item.energy_lamps.length>0" class="pr-3">
                                                    <details-monitoring-zone :zone=item />
                                                </div>
                                                <div v-else class="pr-3">

                                                </div>
                                                <!-- :abilita="item.energy_lamps!=null && item.energy_lamps.length > 0" -->
                                                <!-- <details-monitoring-zone :zone=item :abilita="item.energy_lamps!=null && item.energy_lamps.length > 0"/> -->
                                            </b-col>
                                            <b-col cols="6" class="justify-content-end">
                                                <delete-monitoring-zone :zone=item />
                                            </b-col>
                                    </b-row>
                                </b-col>
                                </b-row>
                            </div>

                            <!-- CARD WITH DONUT CHART -->
                            <div v-if="item.energy_lamps!=null && item.energy_lamps.length>0" class="container-fluid" >
                                <Tabs card lazy class="p-2">
                                    <TabItem :name="$t('energy.energy_saving')" class="pt-5">

                                        <grafico-donut-energy :key="keyGraph" v-if="energyZoneGraph(item) != null" :graphData="energyZoneGraph(item)"/>
                                            <b-row class="justify-content-center">
                                                <b-col cols="9">
                                                <div class="d-flex justify-content-left mt-4">
                                                    <i class="fa fa-minus mt-1 ml-5 mr-2" style="color:orange"></i>
                                                    <p class="typo-title">{{$t('energy.energy_consumed')}}: <strong>{{(Math.round(item.energy_consumed)).toLocaleString('it')}} kWh</strong></p>
                                                </div>
                                                <div class="d-flex justify-content-left mt-1">
                                                    <i class="fa fa-minus mt-1 ml-5 mr-2" style="color:#29CC96"></i>
                                                    <p class="typo-title">{{$t('energy.energy_saved')}}: <strong>{{(Math.round(item.energy_saved)).toLocaleString('it')}} kWh</strong></p>
                                                </div>
                                                <div class="d-flex justify-content-left mt-1">
                                                    <i class="fa fa-clock mt-1 ml-5 mr-2" style="color:grey"></i>
                                                    <p class="typo-title">{{$t('energy.hours_operation')}}: <strong>{{(Math.round(item.working_time)).toLocaleString('it')}} h</strong></p>
                                                </div>
                                                </b-col>
                                            </b-row>

                                    </TabItem>
                                    <TabItem :name="$t('energy.environmental_benefits')"  class="pt-4">
                                            <b-row class="d-flex mt-5 ml-5">
                                                <b-col cols="3" >
                                                    <i class="fa fa-plug fa-2x mt-1" style="color:#009DE0;"></i>
                                                </b-col>
                                                <b-col cols="8">
                                                    <p class="typo-title mt-2">{{$t('energy.energy_saved')}}: <strong>{{(Math.round(item.energy_saved)).toLocaleString('it')}} kWh</strong></p>
                                                </b-col>
                                            </b-row>
                                            <b-row class="d-flex  mt-4 ml-5">
                                                <b-col cols="3" >
                                                    <i class="fa fa-cloud fa-2x mt-1" style="color:gray;"></i>
                                                </b-col>
                                                <b-col cols="8">
                                                    <p class="typo-title mt-2">{{$t('energy.CO2')}}: <strong>{{(Math.round(item.energy_saved*0.5)).toLocaleString('it')}} Kg</strong></p>
                                                </b-col>
                                            </b-row>
                                            <b-row class="d-flex mt-4 ml-5">
                                                <b-col cols="3">
                                                    <i class="fa fa-tint fa-2x mt-1 pl-2" style="color:black;"></i>
                                                </b-col>
                                                <b-col cols="8">
                                                    <p class="typo-title mt-2">{{$t('energy.oil')}}: <strong>{{(item.energy_saved*0.000187).toFixed(2).toLocaleString('it')}}</strong></p>
                                                </b-col>
                                            </b-row>
                                            <b-row class="d-flex mt-4 ml-5">
                                                <b-col cols="3">
                                                    <i class="fa fa-tree fa-2x mt-1 pl-2" style="color:green;"></i>
                                                </b-col>
                                                <b-col cols="8">
                                                    <p class="typo-title mt-2">{{$t('energy.trees')}}: <strong>{{(Math.round(item.energy_saved/20)).toLocaleString('it')}}</strong></p>
                                                </b-col>
                                            </b-row>
                                    <!-- coefficienti utilizzati -->
                                            <b-row class="mt-5 ml-5">
                                                <p class="typo-coeff"> *{{$t('energy.coeff')}}: CO2 eq = 0.5 | TEP eq = 0.000187 | 1 tree = 10kg CO2</p>
                                            </b-row>
                                    </TabItem>
                                </Tabs>
                            </div>

                            <!-- CARD WITH NO LAMPS -->
                            <!-- style="height:450px;" -->
                            <div v-else class="container-fluid text-center p-5">
                                <span class="typo-title"><b>{{$t('monitoring_zone.no_lamps_in_zone')}}</b></span>
                            </div>

                            <!-- CARD FOOTER -->
                            <div v-if="item.energy_lamps!=null && item.energy_lamps.length>0" slot="footer">
                                <span class="typo-title"><b>{{(item.energy_lamps.length + " " + $t('monitoring_zone.lamps_in_zone')).toLowerCase()}}</b></span>
                            </div>

                        </b-card>

                    </b-col>
                    <b-col>
                        <add-monitoring-zone :plant=this.plantDetails></add-monitoring-zone>
                    </b-col>
                </b-row>

            </div>

        </div>

    </div>
</template>

<script>

import NavBarMain from '@/components/NavBarMain'
import BannerProExpired from '@/components/BannerProExpired';
import BannerPro from '@/components/BannerPro';
import AddMonitoringZone from '@/components/MonitoringZone/AddMonitoringZone.vue';
import DeleteMonitoringZone from '@/components/MonitoringZone/DeleteMonitoringZone.vue';
import DetailsMonitoringZone from '@/components/MonitoringZone/DetailsMonitoringZone.vue';
import GraficoDonutEnergy from '@/components/GraficoDonutEnergy'


import { mapState } from 'vuex';

export default {
    name: 'Zone',
    components: {
        NavBarMain,
        Event,
        BannerPro,
        BannerProExpired,
        AddMonitoringZone,
        DeleteMonitoringZone,
        DetailsMonitoringZone,
        GraficoDonutEnergy
    },
    props: ['plantId'],
    data() {
        return {
            highlightedLamp: "",
            filtro: "",
            tabIndex: 0,
            editingZone: false,
            currentZone: null,
            nameZone: '',
            maxchar: 50,
            lampToRemove:null,
            draggedLamp: null,
            showDropZone: false,
            imgLoaded: false,
            imgUploaded: false,
            picLoaded: {},
            keyGraph: 0,
            updatingName: false,
            dropZoneOptions: {
                url: process.env.VUE_APP_API_REST_URL,
                maxFilesize: 1.5,
                acceptFiles: "image/*",
                autoProcessQueue: false,
                autoQueue: false,
                maxFiles: 1
            },
            dragging: false,
            drgX: '0px',
            drgY: '0px',
            dragStartEv: null,
            lampListFields: [
                {key: 'id', label: 'ID' },
                {key: 'status', label: 'Stato'}
            ],
            allLampsFields: [
                {key: 'id', label: 'ID' },
                {key: 'cu_id', label: 'Centrale'},
                {key: 'desc', label: 'Nome'}
            ],
            listDeviceFields:[

            ],
            currentAmbiente: {},
            selectedLamp: null,
            theme: 'bootstrap4',
            template: 'default',
            filtroLampadeLibere: false,
            table_zone_energy: null
        }

    },
    filters: {

        tipoCentrale: function(value) {
            if (value == 'cablecom') return "Centrale CableCom"
            return "Centrale " + value
        },

    },
    computed: {
        ...mapState(['loading','error','commandsPending','commandResponse']),
        zoneNameInfo()
        {
            const nl = this.nameZone.length;
            const validChars = /^[\x20-\x7FÅÆØåæø]*$/.test(this.nameZone);
            if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
            if (nl > this.maxchar || !validChars)
            {
                return "<b style=\"color:red\">" + nl + "/" + this.maxchar + " Caratteri</b>";
            }
            return "" + nl + "/" + this.maxchar + " Caratteri";
        },
        rndId() {
            return Math.random();
        },
        plantDetails() {
            const plant = this.$store.state.currentPlant;
            if (plant == null){
                return null;
            }
            if (plant.id != this.plantId) return null;
            return plant;
        },
        monitoringZonesDetails() {
            return this.$store.state.monitoringZones;
        },
        unitsDetails() {
            return this.$store.state.plantUnits;
        },
        lampsTableEnergy() {
            this.lampEnergyData();
            return this.table_zone_energy;
        },
    },
    mounted() {
        console.log("zone mounted, idImpianto=" + this.plantId + ", plantDetails:" + this.plantDetails)
        if (this.$store.state.user != null && this.error == null && this.plantDetails == null && !this.$store.state.connecting && this.$store.state.socket != null && this.$store.state.socket.isConnected)
        {
            this.$store.dispatch('loadPlantDetails', this.plantId)
        }
        else if (this.plantDetails != null) {
            var dataReady = this.loadData();
            console.log("dataReady="+dataReady);
        }
    },
    watch: {
        loading(val) {
            console.log("zone loading changed:" + val+", error=" + this.error)
            if (val == false && this.error == null) {
                var dataReady = this.loadData();
                console.log("dataReady="+dataReady);
            }

        },
        unitsDetails(val,oldval) {
            console.log("aggiornato unitsDetails",val,oldval);
        },
        monitoringZonesDetails(val,oldval) {
            console.log("aggiornato monitoring Zones",val,oldval);
        },
        lampsTableEnergy(val,oldval) {
            console.log("aggiornato lamps table energy", val, oldval);
            this.keyGraph++;
        },
        commandsPending(val) {
            console.log("commandsPending " + val, "configInProgress =" + this.configInProgress);
        },
        commandResponse(val) {
            console.log("updated commandResponse:",val);
            if (val.command == 'updateMonitoringZone' && val.pending == false && val.error.data == '')
            {
                    console.log("monitoring zone updated:",val);
                    this.editingZone = false;
                    this.$store.dispatch('loadPlantMonitoringZones', this.plantId);
            }
        }
    },
    methods: {
        loadData() {
            if (this.plantDetails == null) {
                this.$store.dispatch('loadPlantDetails', this.plantId)
                return false;
            }
            if (this.monitoringZonesDetails == null) {
                console.log("ricarico zone di monitoraggio");
                this.$store.dispatch('loadPlantMonitoringZones', this.plantId)
                return false;
            }
            if(this.unitsDetails == null) {
                console.log("carico units details")
                this.$store.dispatch('loadUnitsDetails', this.plantId)
                return false;

            } else {
                console.log("control unit pronte: ", this.unitsDetails);
                console.log("zone di monitoraggio pronte: ", this.monitoringZonesDetails);
                console.log("tabella lampade energia pronte: ", this.lampsTableEnergy);
            }
            return true;
        },
        editZoneName(zone)
        {
            this.currentZone = zone;
            this.nameZone = zone.zoneName;
            this.editingZone = true;
        },
        abortZoneName() {
            this.editingZone = false;
        },
        saveZoneName() {
           console.log("Save nome: ", this.nameZone , "su zona :" , this.currentZone);
           const validChars = /^[\x20-\x7F]*$/.test(this.nameZone);
            if (!validChars) {
                console.log("Invalid chars");
                this.$bvModal.msgBoxOk("La descrizione della zona non può contenere caratteri speciali e lettere accentate");
                return;
            }

            if (this.nameZone.length > this.maxchar) {
                console.log("Troppo lunga");
                this.$bvModal.msgBoxOk("La descrizione della zona non può superare i " + this.maxchar +" caratteri");
                return;
            }

            this.currentZone.zoneName=this.nameZone;
            this.$store.dispatch("updateMonitoringZone", this.currentZone);
            console.log("Zone Description param to save",this.currentZone.zoneName);
            this.updatingZone = true;
        },
        ruoloUtente(id) {
            let pusers = this.$store.state.currentPlant.plant_users;
            if (pusers == null || pusers.length == 0) return "?";
            let user = pusers.filter(function(u){
                return u.userid == id;
            });
            if (user != null && user.length > 0)
            {
               return user[0].role;
            }
            return "?";
        },

        lampEnergyData()
        {
            this.table_zone_energy=[];

            //crea un array con tutte le lampade di illuminazione presenti in unitsDetails
            var table_lamp_energy=[];
            if (this.unitsDetails == null) return null;
            this.unitsDetails.forEach(function(u){
                if (u.lamps_illum != null && u.lamps_illum.length > 0) {
                    u.lamps_illum.forEach(function(l){
                        table_lamp_energy.push(l);
                    });
            }})

            //crea un array con tutte le zone di monitoraggio presenti in monitoringZonesDetails
            var temp_zone=null;
            var temp_energy_table=[];
            if (this.monitoringZonesDetails == null) return null;
            this.monitoringZonesDetails.forEach(function(z){
                //creo un array temp_energy_table con tutte le zone di monitoraggio presenti in monitoringZonesDetails
                //che vengono aggiornate con i dati real time di tutte le lampade di illuminazione presenti in table_lamp_energy
                temp_zone=z;
                temp_energy_table.push(temp_zone);

                if (z.lamps != null && z.lamps.length > 0) {

                    temp_zone.energy_lamps=[];
                    temp_zone.energy_consumed=parseInt(0);
                    temp_zone.energy_saved=parseInt(0);
                    temp_zone.energy_substituted = (0);
                    temp_zone.working_time = (0);
                    //per ogni lampada di illuminazione presente in una zona di monitoraggio,
                    //ricerco la corrispondente lampada di illuminazione in table_lamp_energy, cioè tutte le lampade di illuminazione presenti in unitsDetails
                    //con tutti i dati, l'aggiungo a temp_zone.energy_lamps e aggiorno i consumi energetici consuntivi
                    z.lamps.forEach(function(l){
                        table_lamp_energy.forEach(function(lamp){

                        if(l.id==lamp.id){
                            temp_zone.energy_lamps.push(lamp);
                            temp_zone.energy_consumed=temp_zone.energy_consumed + parseFloat((lamp.energia_consumata/1000).toFixed(1));
                            temp_zone.energy_saved=temp_zone.energy_saved + parseFloat((lamp.energia_risparmiata/1000).toFixed(1));
                            temp_zone.energy_substituted = temp_zone.energy_substituted + parseFloat((lamp.energia_sostituita/1000).toFixed(1));
                            temp_zone.working_time=temp_zone.working_time+parseInt(lamp.TimeOn);
                        }
                    })
                });

            }})

            this.table_zone_energy=temp_energy_table.sort((a,b)=>a.creationTimestamp>b.creationTimestamp?1:-1) ;
            console.log("zone energy table", this.table_zone_energy);

        },
        energyZoneGraph(zone) {
            if (zone == null) return null;
                return ["energy",zone.energy_saved.toFixed(0),zone.energy_consumed.toFixed(0)];
        },
    }
}
</script>

<style lang="scss">

.button-zone{
    height: 200px;
    width: 200px;
    background: rgb(255,255,255);
    background: linear-gradient(180deg, rgba(125,240,255,1) 0%, rgba(80,185,230,1) 100%);
    border-radius: 10px;
    border: 2px solid #8ad;
}

.close-x{
    font-size: 1.3125rem;
    font-weight: 400;
    color: white;
    opacity:1;
}

.modal-fullscreen .modal-dialog {
    max-width: 100%;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    z-index: 100000;
}
    .nopad {
       padding: 0;
    }
    .imgDiv {
        position: relative;
    }

    .dotImg {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 13px;
        height: 13px;

    }

    @keyframes highlightedDotAnim {
        0% {background-color: rgba(255,255,255,0);}
        50% {background-color: rgba(255,255,0,0.8);}
        100% {background-color: rgba(255,255,255,0);}
    }

    .dotImgHighlight {
        background-color: #ffff00;
        width: 61px;
        height: 61px;
        padding: 24px;
        border-radius: 32px;
        animation-name: highlightedDotAnim;
        animation-duration: 1s;
        animation-iteration-count: infinite;
    }

    .dotImgBig {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        float: left;
        width: 50px;
        height: 50px;
        padding: 16px;
        background-color: #ffffff11;
        border-radius: 32px;
        z-index: 10000;
    }

    .dotSel {
        background-color: #00990044;
    }

    .modal-xl {
        max-width: 95%;

    }
    .uploadButton {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .infoTip {
        position: absolute;
        right: 5px;
        bottom: 5px;
    }

    .closeButton {
        position: absolute;
        right: 0;
        top: 0;
    }

    #dropzoneContainer {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #eeeeee;
        top: 0;
        margin-top: auto;
        margin-bottom: auto;
        padding: 16px;
        z-index: 11000;
    }
    #dropzone {
        height: 100%;
    }
    .draggableRow {
        cursor: pointer;
    }

    .lampUsed {
        background-color: #ffff;
    }

    .highlightedRow {
        background-color: #b3d3ec;
    }

    .highlightedAdded {
        background-color: #ffff;
    }


    .green {
        color: #009900;
    }
    .error {
        color: #cc0000;
    }

    #modal-ambiente .modal-content {
        min-height: 600px;
    }

</style>
